export default "__VITE_ASSET__4vBHyvTS__"